module.exports = __webpack_public_path__ + "assets/img/sponlax-logo.5c002929.svg";